module.exports = __webpack_public_path__ + "static/img/cocina_17.9feb5fd2.png";